
export const columns = [
    {
        title: '#',
        dataIndex: 'lmt',
        key: 'lmt',
        width: 50,
        customRender: (text, record, index) => {
            return index + 1
        },
    },
    // {
    //     title: '仓库名称',
    //     dataIndex: 'warehouse',
    //     key: 'warehouse',
    // },
    {
        title: '发货类型',
        dataIndex: 'deliverType',
        key: 'deliverType',
        customRender: (text, record, index) => {
            return {0:'FBA发货',1:'大件普通发货',2:'小件普通发货'}[text]
        },
    },
    {
        title: '货代公司',
        dataIndex: 'logisticsCompanyCode',
        key: 'logisticsCompanyCode',
        scopedSlots: {
            customRender: 'logisticsCompany'
        }
    },
    {
        title: '类型',
        dataIndex: 'boxType',
        key: 'boxType',
        customRender: (text, record, index) => {
            return {1:'容器',2:'箱子',3:'包裹'}[text]
        },
    },
    {
        title: '重量上限 KG',
        dataIndex: 'weightLimit',
        key: 'weightLimit'
    },
    {
        title: '美金上限 $',
        dataIndex: 'priceLimit',
        key: 'priceLimit'
    },
    {
        title: '操作',
        dataIndex: 'idAction',
        key: 'idAction',
        scopedSlots: {
            customRender: 'action'
        }
    },
]